import { parseISO } from "date-fns";
import type React from "react";
import { useTranslation } from "react-i18next";

import { TextWithCopy } from "./TextWithCopy";

type Props = {
  id: string;
  createdAt?: string;
  updatedAt?: string;
};
export const DetailSubHeader: React.FC<Props> = ({ id, createdAt, updatedAt }) => {
  const { t } = useTranslation();
  const showUpdatedAt = updatedAt && updatedAt !== createdAt;

  return (
    <div className="flex w-full flex-wrap items-center gap-x-4 gap-y-1 text-[13px] text-fg-1">
      <span className="flex items-center gap-1">
        <span className="text-fg-3">{t("model.common.id")}:</span>
        <TextWithCopy text={id} />
      </span>

      {createdAt && (
        <span className="flex items-center gap-1">
          <span className="text-fg-3">{t("model.common.createdAt")}:</span>
          {t("date.long", { date: parseISO(createdAt) })}
        </span>
      )}

      {showUpdatedAt && (
        <span className="flex items-center gap-1">
          <span className="text-fg-3">{t("model.common.updatedAt")}:</span>
          {t("date.long", { date: parseISO(updatedAt) })}
        </span>
      )}
    </div>
  );
};
